if (!customElements.get('trust-indicators-slider')) {


  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);
    }
    
    initSlider(swiperOptions) {
      // Create unique IDs for this carousel instance
      const carouselId = `carousel-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      this.setAttribute('data-carousel-id', carouselId);
      
      // Find navigation buttons - try multiple approaches
      let nextBtn = this.querySelector('.swiper-button--next');
      let prevBtn = this.querySelector('.swiper-button--prev');
      
      // If not found inside, try parent section
      if (!nextBtn || !prevBtn) {
        const section = this.closest('section') || this.closest('[data-section-id]');
        if (section) {
          nextBtn = nextBtn || section.querySelector('.swiper-button--next');
          prevBtn = prevBtn || section.querySelector('.swiper-button--prev');
        }
      }
      
      // Only assign to this carousel if buttons are not already assigned to another carousel
      if (nextBtn && !nextBtn.hasAttribute('data-carousel-id')) {
        nextBtn.setAttribute('data-carousel-id', carouselId);
        nextBtn.id = `next-${carouselId}`;
      }
      if (prevBtn && !prevBtn.hasAttribute('data-carousel-id')) {
        prevBtn.setAttribute('data-carousel-id', carouselId);
        prevBtn.id = `prev-${carouselId}`;
      }

      this.slider = new Swiper(this, {
        slidesPerView: 1.1,
 
        navigation: {
          nextEl: (nextBtn && nextBtn.getAttribute('data-carousel-id') === carouselId) ? `#next-${carouselId}` : null,
          prevEl: (prevBtn && prevBtn.getAttribute('data-carousel-id') === carouselId) ? `#prev-${carouselId}` : null,
        },
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: 3,
            loop: false
          }
        }
      });
    }
  }

  customElements.define('trust-indicators-slider', TrustIndicatorsSlider);
}
